export default "__VITE_ASSET__d5262e9e__"